import { render, staticRenderFns } from "./PageWhales.vue?vue&type=template&id=ef0bfa1c"
import script from "./PageWhales.vue?vue&type=script&lang=js"
export * from "./PageWhales.vue?vue&type=script&lang=js"
import style0 from "./PageWhales.vue?vue&type=style&index=0&id=ef0bfa1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports